'use strict';

const Answer = require('./answer');

const SiteAnswer = Answer.extend({
    idAttribute: [ 'questionId', 'responseId', 'programDataSetId' ]
});

module.exports = SiteAnswer;